<template>
  <div class="masterright">
    <div id="side-menu" :style="hideStyle">
      <div id="pages">
        <div class="page" v-for="n in $store.getters.totalPages()" :key="n">
          <strong class="numpagespace">{{ n }}</strong>
          <img class="imgpages" :src="getImagePath(n)" v-on:click="switchPage(n)">
        </div>
      </div>
      <div id="show-hide" @click="toggleShowPageList">
        <i v-if="$store.state.showPageList" class="fas fa-angle-double-left"></i>
        <i v-else class="fas fa-angle-double-right"></i>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'side-menu-page-list',

    methods: {
      getImagePath (index) {
        return this.$store.state.outputPath + '/thumbnails/' + index + '.png'
      },

      switchPage (pageNum) {
        this.$store.commit('setDisablePageNavigation', true)
        this.$store.commit('setCurrentPage', pageNum)
        this.$bus.emit('pageChange', pageNum)
        this.$store.commit('setShowPageList', false)
        this.$bus.emit('hidePageFields')
        this.visible = false
      },

      toggleShowPageList () {
        this.$store.commit('toggleShowPageList')
      }
    },

    computed: {
      hideStyle: function () {
        return this.$store.state.showPageList ? 'left:0;' : ''
      }
    }
  }
</script>

<style lang="scss" scoped>
  .masterright {
      left: 0;
  /* position: absolute */ }

  .numpagespace {
      padding-right: 9px; }

  #side-menu {
      width: 303px;
      height: 100%;
      position: fixed;
      top: 0;
      /* left: 0%; */
      left: -266px;
      z-index: 105;
      /* padding-top: 35px */
      overflow: hidden;
      text-align: center;
      -webkit-transition: all 0.2s ease;
      -moz-transition: all 0.2s ease;
      -ms-transition: all 0.2s ease;
      -o-transition: all 0.2s ease;
      transition: all 0.2s ease; }

  #show-hide {
      background-color: white;
      width: 10%;
      height: 60px;
      position: absolute;
      right: 7px;
      top: 45%;
      color: #25b912;
      border: 1px solid #e5e4e4;
      border-top-right-radius: 10px;
      border-bottom-right-radius: 8px;
      cursor: pointer;
      text-align: center;
      -webkit-box-shadow: 3px 5px 6px 0px #2f302f;
      box-shadow: 3px 5px 6px 0px #2f302f; }

  i.fa-angle-double-right {
      display: block;
      line-height: 60px;
      font-size: 150%; 
  }

  i.fa-angle-double-left {
      display: block;
      line-height: 60px;
      font-size: 150%; 
  }

  #pages {
      background-color: #f7f7f7;
      width: 200pt;
      height: 100%;
      overflow-x: none;
      overflow-y: scroll;
      border-right: 1px solid black;
      padding-top: 30px;
      -webkit-box-shadow: 5px 8px 10px #2f302f;
      box-shadow: 5px 8px 10px #2f302f; }

  .page {
      position: relative;
      margin-bottom: 15px; }

  .imgpages {
      width: 80%;
      height: auto;
      border: 1px solid black; }
  .imgpages:hover {
      -webkit-box-shadow: 5px 5px 8px -3px rgba(0, 0, 0, 0.8);
      box-shadow: 5px 5px 8px -3px rgba(0, 0, 0, 0.8);
      cursor: pointer; }

  .active-thumb {
      -webkit-box-shadow: 5px 8px 6px #6ef36e;
      box-shadow: 5px 8px 6px #6ef36e; }
 
</style>




// WEBPACK FOOTER //
// src/components/editor/main/SideMenuPageList.vue